<a [routerLink]="element.id" class="workspace-row" [class.disabled]="disabled">
  <div class="workspace-info">
    <mat-icon class="icon-primary">folder_open</mat-icon>
    <div class="title-group">
      <h3 class="title">{{ element.name }}</h3>
      <p class="description">{{ element.id }}</p>
    </div>
  </div>

  <div class="status-group">
    <mat-chip-listbox>
      <mat-chip [class]="element | workspaceStatusClass" highlighted>
        {{ element | workspaceStatus }}
      </mat-chip>
    </mat-chip-listbox>
  </div>

  <div class="metadata-group">
    <div class="metadata-item">
      <mat-icon>update</mat-icon>
      <span>{{ element.last_activity | date: 'shortDate' }}</span>
    </div>
  </div>
</a>
@if (disabled) {
  <div class="disabled-tooltip" matTooltip="You don't have access to this workspace!" [matTooltipDisabled]="!disabled"></div>
}
